// extracted by mini-css-extract-plugin
export var country = "ProductItem-module--country--6b2fc";
export var img = "ProductItem-module--img--0d32c";
export var label = "ProductItem-module--label--a21e0";
export var labels = "ProductItem-module--labels--2d715";
export var marks = "ProductItem-module--marks--03397";
export var productItem = "ProductItem-module--product-item--90697";